import React from "react";
import { FaShareAlt, FaTimes, FaHeart, FaFileExport } from "react-icons/fa";

export default function LexiqueToolbar({
  ui,
  availableLetters,
  onChange,
  debouncedQ,
  setDebouncedQ,
  onReset,
  onShare,
  shareCopied,
  onExport,
}) {
  return (
    <div className="flex flex-col gap-3">
      {/* Recherche + actions */}
      <div className="flex flex-col sm:flex-row gap-3 items-stretch sm:items-center">
        <input
          type="text"
          placeholder="Rechercher (japonais, traduction)…"
          className="input input-bordered w-full dark:bg-slate-200 dark:text-black"
          value={debouncedQ}
          onChange={(e) => setDebouncedQ(e.target.value)}
        />

        <div className="flex items-center gap-2">
          {/* Favoris only */}
          <button
            type="button"
            onClick={() => onChange({ favOnly: !ui.favOnly })}
            title={ui.favOnly ? "Afficher tout le lexique" : "Afficher uniquement mes favoris"}
            aria-label="Basculer favoris"
            className={`w-10 h-10 grid place-items-center rounded-xl ring-1 transition transform
              focus:outline-none focus:ring-2 focus:ring-violet-400
              hover:scale-105 active:scale-95
              ${
                ui.favOnly
                  ? "bg-red-50 ring-red-200 text-red-500 dark:bg-red-900/20 dark:ring-red-800"
                  : "bg-slate-100 ring-slate-200 text-slate-500 dark:bg-slate-800 dark:ring-slate-700"
              }`}
          >
            <FaHeart className="text-lg" />
          </button>

          {/* Export CSV */}
          <button
            type="button"
            onClick={onExport}
            title="Exporter la liste filtrée (CSV)"
            aria-label="Exporter CSV"
            className="w-10 h-10 grid place-items-center rounded-xl ring-1 transition transform
              focus:outline-none focus:ring-2 focus:ring-violet-400
              hover:scale-105 active:scale-95
              bg-slate-100 ring-slate-200 text-slate-500 dark:bg-slate-800 dark:ring-slate-700"
          >
            <FaFileExport className="text-lg" />
          </button>

          {/* Partager */}
          <button
            type="button"
            onClick={onShare}
            title={shareCopied ? "Lien copié !" : "Copier un lien partageable"}
            aria-label="Partager"
            className={`w-10 h-10 grid place-items-center rounded-xl ring-1 transition transform
              focus:outline-none focus:ring-2 focus:ring-violet-400
              hover:scale-105 active:scale-95
              ${
                shareCopied
                  ? "bg-emerald-50 ring-emerald-200 text-emerald-600 dark:bg-emerald-900/20 dark:ring-emerald-800"
                  : "bg-slate-100 ring-slate-200 text-slate-500 dark:bg-slate-800 dark:ring-slate-700"
              }`}
          >
            <FaShareAlt className={`text-lg ${shareCopied ? "animate-pulse" : ""}`} />
          </button>

          {/* Reset */}
          <button
            type="button"
            onClick={onReset}
            title="Réinitialiser"
            aria-label="Reset filtres"
            className="w-10 h-10 grid place-items-center rounded-xl ring-1 transition transform
              focus:outline-none focus:ring-2 focus:ring-violet-400
              hover:scale-105 active:scale-95
              bg-slate-100 ring-slate-200 text-slate-500 dark:bg-slate-800 dark:ring-slate-700"
          >
            <FaTimes className="text-lg" />
          </button>
        </div>
      </div>

      {/* Alphabet + tri */}
      <div className="flex flex-col gap-3">
        {/* Alphabet scroll horizontal */}
        <div className="overflow-x-auto">
          <div className="flex items-center gap-2 w-max space-y-2">
            {availableLetters.map((L) => (
              <button
                key={L}
                onClick={() => onChange({ letter: L })}
                className={`px-3 py-1.5 text-sm rounded-full ring-1 transition
                  ${ui.letter === L
                    ? "bg-sky-600 text-white ring-sky-600"
                    : "bg-white/70 dark:bg-slate-900/50 text-slate-700 dark:text-slate-200 ring-slate-300 dark:ring-slate-700 hover:ring-sky-300 mb-1"}`
                }
              >
                {L}
              </button>
            ))}
          </div>
        </div>

        <div className="flex items-center gap-3">
          <label className="text-sm text-slate-600 dark:text-slate-300">Trier par :</label>
          <select
            className="select select-bordered w-52 dark:bg-slate-200 dark:text-black"
            value={ui.sort}
            onChange={(e) => onChange({ sort: e.target.value })}
          >
            <option value="jp">Japonais (A→Z)</option>
            <option value="fr">Français (A→Z)</option>
          </select>
        </div>
      </div>
    </div>
  );
}
